import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EParkingType } from '../../../../../../../json_query';
import { setParking } from '../../../../../../state/advanced/parking';

import { Parking as ParkingComponent } from './parking';

export const Parking = connect(
  (state: IAppState) => ({
    value: (state.filters.jsonQuery.parking_type && state.filters.jsonQuery.parking_type.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: EParkingType[]) => {
      dispatch(setParking(value));
    },
  }),
)(ParkingComponent);
